<template>
    <div 
        class="mb-8 flex justify-start items-center w-full space-x-4"
        > <!-- :class="{'flex-row-reverse': index%2 !== 0}" -->
        <div class="order-1 "></div>
        <div class="z-10 flex items-center order-1 bg-light-green-500 shadow-xl w-4 h-4 rounded-full"></div>
        <div class="order-1 bg-white dark:bg-gray-700 rounded shadow-xl lg:w-5/12 px-6 py-4 flex space-x-5">
            <button
                title="Visualize report" 
                class=" text-blue-500 dark:text-blue-400 flex items-center h-28"
                @click.prevent="openPdf">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="fill-current h-14 lg:h-28"><path d="M88 304H80V256H88C101.3 256 112 266.7 112 280C112 293.3 101.3 304 88 304zM192 256H200C208.8 256 216 263.2 216 272V336C216 344.8 208.8 352 200 352H192V256zM224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM64 224C55.16 224 48 231.2 48 240V368C48 376.8 55.16 384 64 384C72.84 384 80 376.8 80 368V336H88C118.9 336 144 310.9 144 280C144 249.1 118.9 224 88 224H64zM160 368C160 376.8 167.2 384 176 384H200C226.5 384 248 362.5 248 336V272C248 245.5 226.5 224 200 224H176C167.2 224 160 231.2 160 240V368zM288 224C279.2 224 272 231.2 272 240V368C272 376.8 279.2 384 288 384C296.8 384 304 376.8 304 368V320H336C344.8 320 352 312.8 352 304C352 295.2 344.8 288 336 288H304V256H336C344.8 256 352 248.8 352 240C352 231.2 344.8 224 336 224H288zM256 0L384 128H256V0z"/></svg>
            </button>
            <div class="w-full">
                <div class="flex items-center space-x-3">
                    <router-link :to="`/${$store.state.locale}/report/${inventory.id}`" class="mb-3 text-blue-500 dark:text-gray-50 text-xl capitalize hover:underline">
                        {{ setReferenceDate }}
                    </router-link>
                    <span
                        class="py-1 px-2 text-xs rounded-full flex items-center justify-center whitespace-nowrap"
                        :class="setStatusClasses">
                        {{ $t(`reports.status.${setStatus}`, $store.state.locale) }}
                    </span>
                </div>
                <p
                    v-if="setStatus === 'declined' && inventory.declined_reason"
                    class="text-sm text-red-500 mb-1">
                    {{ $t('reports.status.declined_reason', $store.state.locale) }}: {{ inventory.declined_reason }}
                </p>
                <ul class="text-sm leading-snug tracking-wide text-blue-500 dark:text-gray-400 text-opacity-100">
                    <li>
                        {{ $t('reports.component.products', $store.state.locale) }}: {{ inventory.products_count }}
                    </li>
                    <li>
                        {{ $t('reports.component.created_at', $store.state.locale) }}: {{ setCreatedAt }}
                    </li>
                </ul>
                <div class="w-full flex items-center justify-end mt-2">
                    <router-link 
                        :to="`/${$store.state.locale}/report/${inventory.id}`"
                        class="w-full block lg:max-w-max rounded px-4 py-1 hover:bg-blue-500 dark:hover:bg-blue-500 border border-blue-500 dark:hover:border-blue-500 dark:border-blue-400 text-blue-500 dark:text-blue-400 hover:text-white dark:hover:text-white flex items-center justify-center space-x-2 duration-300">
                        <span>{{ $t('reports.component.details', $store.state.locale) }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" class="w-4 fill-current"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, ref }  from 'vue';
import { useStore }  from 'vuex';
import moment        from 'moment';
import { useI18n } from 'vue-i18n';
import SnackbarComposables  from '../../composables/SnackbarComposables';
import InventoryService from '../../services/InventoryService'
export default 
{
    props: 
    {
        inventory: {required:true},
        index: {required: true}
    },
    setup(props)
    {
        const store = useStore();
        const report = ref('');
        const {addSnackbar} = SnackbarComposables();
        const {downloadReport} = InventoryService();
        const {t, locale} = useI18n();

        /** 
         *
         * Computed
         *
         */
        const setReferenceDate = computed( () => 
        {
            return moment(props.inventory.reference_date).format('MMMM YYYY');
        });
        const setCreatedAt = computed( () => 
        {
            return store.state.locale === 'en' 
                ? moment(props.inventory.created_at).format('YYYY-MM-DD') 
                : moment(props.inventory.created_at).format('DD/MM/YYYY');
        });
        // Legacy inventories predate the async lifecycle and carry no
        // status: their pdf already exists, treat them as published (E23).
        const setStatus = computed( () => props.inventory.status ?? 'published');
        const setStatusClasses = computed( () =>
        {
            switch(setStatus.value)
            {
                case 'draft': return 'bg-gray-100 text-gray-600';
                case 'submitted': return 'bg-yellow-50 text-yellow-600';
                case 'declined': return 'bg-red-50 text-red-500';
                case 'published': default: return 'bg-light-green-50 text-light-green-600';
            }
        });

        /** 
         *
         * Methods
         *
         */
        const openPdf = () => 
        {
                if(report.value)
                {
                    var byteCharacters = atob(report.value);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
            else return addSnackbar('warning', t('reports.no_file', locale.value));
        };
        const getReport = async () => 
        {
            // The pdf exists only once the report is published (async flow)
            if(!props.inventory.report) return;
            const res = await downloadReport(props.inventory.report);
            if(res.data) report.value = res.data;
        };

        /* Hooks */

        getReport();
        locale.value = store.state.locale;

        return {
            /* Data */
            report,
            /* Computed */
            setReferenceDate,
            setCreatedAt,
            setStatus,
            setStatusClasses,
            /* Methods */
            openPdf
        }

    }
}
</script>